<mat-form-field>
    <mat-toolbar>
        <input matInput [value]="
            selectedFileNames.length
              ? selectedFileNames.join(', ')
              : 'Select Images'
        " />
        <ng-container *ngIf="!imageUploaded">
          <button mat-flat-button color="primary" [disabled]="!selectedFiles" (click)="uploadFiles()">
            Upload
          </button>
        </ng-container>
    </mat-toolbar>
    <input type="file" id="fileInput" name="fileInput" accept="image/*" (change)="selectFiles($event)" />
</mat-form-field>

<div>
    <img [src]="preview" class="preview" />
</div>
